import { makeShareChapterUrl } from "../../utils/routes/routes";

export const getShareData = (item, basePath = "") => {  
  const url = makeShareChapterUrl(basePath, item?.start_para_id);

  return {
    url,
    title: item?.label,
    text: decodeHTMLEntries(item?.content.join("\n").replace(/<\/?[^>]+(>|$)/g, "")),
    refCode: item?.start_refcode
  };
};

const decodeHTMLEntries = (text) => {
  const textArea = document.createElement("textarea");
  textArea.innerHTML = text;
  const decode = textArea.value;

  if (textArea.remove) {
    textArea.remove();
  }

  return decode;
};
